import { render, staticRenderFns } from "./BuyerPosts.vue?vue&type=template&id=71ff85ba&"
import script from "./BuyerPosts.vue?vue&type=script&lang=js&"
export * from "./BuyerPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports